import { Box, Link, Typography } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';

interface Props {
    /** Short heading for the empty state. */
    title?: string;
    /** Optional hint (e.g. who can set the welcome doc, or where). */
    hint?: string;
    /** Optional link to the page where the user can edit the welcome doc. */
    editLink?: { to: string; label: string };
}

const DEFAULT_TITLE = 'No welcome document set';

export default function WelcomeEmptyState(props: Props) {
    const { title = DEFAULT_TITLE, hint, editLink } = props;

    return (
        <Box
            sx={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
                flex: 1,
                minHeight: 200,
                padding: 3,
                textAlign: 'center',
                color: 'text.secondary',
            }}
        >
            <Typography variant="h6" component="p" gutterBottom sx={{ fontWeight: 500 }}>
                {title}
            </Typography>
            {hint && (
                <Typography variant="body2" sx={{ maxWidth: 360 }}>
                    {hint}
                </Typography>
            )}
            {editLink && (
                <Link component={RouterLink} to={editLink.to} sx={{ mt: 2 }}>
                    {editLink.label}
                </Link>
            )}
        </Box>
    );
}
